import { CompanyDetails } from "_services/common.service";
import { identity } from "rxjs";


export type AuthState = {
  user: unknown | null;
  login: (userData: unknown) => void;
  logout: () => void;
  
  companyDetails: CompanyDetails | null;
  setCompanyDetails: (details: CompanyDetails) => void;
  getCompanyDetails: () => CompanyDetails | null;
  clearCompanyDetails: () => void;
  
  identityToken: string | null;
  setIdentityToken: (token: string) => void;
  getIdentityToken: () => string | null;
  clearIdentityToken: () => void;
  
  isOnlineHold: boolean;
  setIsOnlineHold: (hold: boolean) => void;
  getIsOnlineHold: () => boolean;
  clearIsOnlineHold: () => void;
};

export const createAuthSlice = (
  set: (state: Partial<AuthState>) => void,
  get: () => AuthState
) => ({
  user: null,
  login: (userData: unknown) => set({ user: userData }),
  logout: () => set({ user: null }),

  identityToken: null,
  setIdentityToken: (token: string) => set({ identityToken: token }),
  getIdentityToken: () => get().identityToken || identity.toString(),
  clearIdentityToken: () => set({ identityToken: null }),

  companyDetails: null,
  setCompanyDetails: (details: CompanyDetails | null) => {
    // console.log("Setting company details:", details);
    return set({ companyDetails: details });
  },
  getCompanyDetails: () => get().companyDetails,
  clearCompanyDetails: () => set({ companyDetails: null }),

  isOnlineHold: false,
  setIsOnlineHold: (hold: boolean) => set({ isOnlineHold: hold }),
  getIsOnlineHold: () => get().isOnlineHold,
  clearIsOnlineHold: () => set({ isOnlineHold: false }),
})